import { useId } from "react";

import { cx } from "../lib/format";

export interface SliderProps {
  value: number;
  onChange: (value: number) => void;
  min: number;
  max: number;
  step?: number;
  disabled?: boolean;
  /** Accessible name. */
  label?: string;
  /** Render the current value beside the track (mono). Default true. */
  showValue?: boolean;
  /** Format the displayed value, e.g. (v) => `${v}ms`. */
  format?: (value: number) => string;
  id?: string;
  className?: string;
}

export function Slider({
  value,
  onChange,
  min,
  max,
  step = 1,
  disabled,
  label,
  showValue = true,
  format,
  id,
  className,
}: SliderProps) {
  const autoId = useId();
  const inputId = id ?? autoId;
  return (
    <div className={cx("flex items-center gap-3", className)}>
      <input
        id={inputId}
        type="range"
        className="va-slider"
        value={value}
        min={min}
        max={max}
        step={step}
        disabled={disabled}
        aria-label={label}
        onChange={(event) => onChange(Number(event.target.value))}
      />
      {showValue && (
        <output
          htmlFor={inputId}
          className="min-w-[3.5rem] text-right font-mono text-xs text-body"
        >
          {format ? format(value) : value}
        </output>
      )}
    </div>
  );
}
